var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLoginShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6708 2.66475C10.8561 3.03524 10.7059 3.48574 10.3354 3.67098L5.44098 6.11819C5.44098 6.11819 5.44099 6.11819 5.44098 6.11819C5.0175 6.32994 4.75 6.76276 4.75 7.23623V16.7641C4.75 17.2376 5.01753 17.6704 5.44091 17.8821L10.3354 20.3294C10.7059 20.5146 10.8561 20.9651 10.6708 21.3356C10.4856 21.7061 10.0351 21.8563 9.66458 21.671L4.77023 19.2238C4.7702 19.2237 4.77025 19.2238 4.77023 19.2238C3.83852 18.758 3.25 17.8056 3.25 16.7641V7.23623C3.25 6.19461 3.8385 5.24239 4.77016 4.77656L9.66459 2.32934C10.0351 2.1441 10.4856 2.29427 10.6708 2.66475Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0303 8.96967C13.3232 9.26256 13.3232 9.73743 13.0303 10.0303L11.8106 11.25H20C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4143 20.4142 12.75 20 12.75H11.8107L13.0303 13.9697C13.3232 14.2626 13.3232 14.7375 13.0303 15.0304C12.7374 15.3233 12.2626 15.3233 11.9697 15.0304L9.46967 12.5304C9.17678 12.2375 9.17678 11.7626 9.46967 11.4697L11.9697 8.96967C12.2626 8.67678 12.7374 8.67677 13.0303 8.96967Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLoginShape);
export default __webpack_public_path__ + "static/media/ic-login-shape.ae772bb018fae9e058e8c5db369d4d8d.svg";
export { ForwardRef as ReactComponent };